import { ISensitiveCommunitiesState, actionTypes } from 'src/ducks/sensitive-communities.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getSensitiveCommunitiesStatus = (
  state: ISensitiveCommunitiesState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
